import Vue from 'vue';
import Vuex from 'vuex';
import fixAddress from './modules/fixAddress'
import selectAddress from './modules/selectAddress';
import material from './modules/material';
import previewImage from './modules/previewImage';
 
Vue.use(Vuex);
 
const store = new Vuex.Store({
  modules: {
		fixAddress,
		selectAddress,
		material,
		previewImage
	},
});
 
export default store;